import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, TextField } from '@mui/material'
import React, { useCallback, useContext, useState } from 'react'
import { MessageContext } from './Contexts'
import ActionButtons from './ActionButtons'
import { setModes } from 'modules/Utils'

export function AddUsersDialog({ mode, setMode, callback, inviteFn, params, heading }) {
  const { messageDispatch } = useContext(MessageContext)

  const [inviteContent, setInviteContent] = useState('')
  const [noMail, setNoMail] = useState(false)

  const inviteUsers = useCallback(async (e, setMode) => {
    try {
      setMode('pending')
      const { data: { success, info } } = await inviteFn({invite_content: inviteContent, no_mail: noMail, ...params})
      if (success) {
        info && messageDispatch({ type: 'info', payload: info })
        await setModes(setMode, ['completing', 1500, ''])
      } else {
        throw new Error(info ? info : 'An error occurred')
      }
      callback && callback()
    } catch (error) {
      setMode('')
      messageDispatch({ type: 'warning', payload: error.message })
    }
  }, [params, inviteContent, noMail, callback, inviteFn, messageDispatch])

  const clearDialog = useCallback(() => {
    setInviteContent('')
    setNoMail(false)
  }, [setInviteContent, setNoMail])

  return (
    <Dialog
      open={mode !== ''}
      aria-labelledby='add-dialog'
      slotProps={{
        transition: { onEnter: clearDialog }
      }}
      disableRestoreFocus
    >
      <DialogTitle>{heading ? heading : 'Add users'}</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              sx={{
                marginTop: 1,
              }}
              label='Email addresses'
              placeholder='1 email address per line'
              multiline
              rows={6}
              fullWidth
              variant='outlined'
              autoFocus
              value={inviteContent}
              onChange={({ target: { value } }) => {
                setInviteContent(value)
              }}
            />

          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={noMail}
                  onChange={({ target: { checked } }) => {
                    setNoMail(checked)
                  }}
                />
              }
              label='Do not send any invitation emails'
            />

          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ActionButtons
          mode={mode}
          setMode={setMode}
          action={inviteUsers}
          cancel={(e, setMode) => setMode('')}
          actionTitle='Invite'
          neverShowEdit={true}
        />
      </DialogActions>
    </Dialog>
  );
}
